import { useState, useEffect } from "react";
import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import { getUserSession } from "../../../util/core/Session";
import Fetch from "../../../util/core/Fetch";
import config from '../../../../application/config/config';

function Form() {

  const [formContent, setFormContent] = useState(<>Carregando...</>);
  const session = getUserSession();

  const pathFrontEnd = '/core/supportprofiles/';
  const pathBackEnd = 'core/configs/';
  const paths = {
    endpointSave: config.endpoints.backend + pathBackEnd + 'save',
    endpointGetByReference: config.endpoints.backend + pathBackEnd + 'getByReference',
    urlGoBack: '',
  }

  const labels = {
    labelTitleAdd: "Administradores de Suporte - Plataforma"
  }

  const getForm = (values) => {
    let form = {
      validateOnChange: true,
      showGoBackButton: false,
      hiddenValues: {
        core_application_instance_id: session.user.application_instance_id,
        reference: 'support_profiles'
      },
      fields: [
        {
          name: 'profiles',
          type: 'multiselect',
          options: [],
          optionsEndpoint: {
            endpoint: config.endpoints.backend + 'core/applicationsprofiles/getall',
            label: 'profile_name',
            value: 'id',
            params: {
              without_admin: true
            }
          },
          label: 'Perfis de Acesso',
          validations: {
            required: false
          },
          columnSize: 12
        },
      ],
      ...paths,
      ...labels
    }
    form.values = values;
    return form;
  }

  useEffect(() => {
    const load = async () => {
      let values = {};
      try {
        const response = await Fetch.post(paths.endpointGetByReference, {
          core_application_instance_id: session.user.application_instance_id,
          reference: 'support_profiles'
        });

        values = response.config || {};

      } catch (error) {
        console.error("Erro durante a execução da função load:", error);
      }
      const form = getForm(values);
      setFormContent(
        <CustomFormContainer
          form={form}
          content={<CustomForm form={form} />} />
      );
    }
    load();
  }, [])

  return (
    <div>
      {formContent}
    </div>
  );
}
export default Form;